var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2766 3.34994C16.0113 3.084 15.6583 2.9375 15.2828 2.9375H14.6595V3.5625C14.6595 4.25175 14.0994 4.8125 13.4109 4.8125H7.79216C7.10366 4.8125 6.54353 4.25175 6.54353 3.5625V2.9375H5.91819C5.1445 2.9375 4.51438 3.56762 4.5135 4.34219L4.5 16.5922C4.49956 16.9681 4.6455 17.3216 4.91084 17.5876C5.17625 17.8535 5.52919 18 5.90469 18H15.2693C16.043 18 16.6731 17.3699 16.674 16.5953L16.6875 4.34531C16.6879 3.96941 16.542 3.61591 16.2766 3.34994ZM10.7529 7.625H14.0796C14.3382 7.625 14.5478 7.83488 14.5478 8.09375C14.5478 8.35262 14.3382 8.5625 14.0796 8.5625H10.7529C10.4943 8.5625 10.2847 8.35262 10.2847 8.09375C10.2847 7.83488 10.4943 7.625 10.7529 7.625ZM10.7529 10.75H14.0796C14.3382 10.75 14.5478 10.9599 14.5478 11.2188C14.5478 11.4776 14.3382 11.6875 14.0796 11.6875H10.7529C10.4943 11.6875 10.2847 11.4776 10.2847 11.2188C10.2847 10.9599 10.4943 10.75 10.7529 10.75ZM10.7529 13.875H14.093C14.3516 13.875 14.5612 14.0849 14.5612 14.3438C14.5612 14.6026 14.3516 14.8125 14.093 14.8125H10.7529C10.4943 14.8125 10.2847 14.6026 10.2847 14.3438C10.2847 14.0849 10.4943 13.875 10.7529 13.875ZM6.76347 7.6435C6.94634 7.46044 7.24278 7.46044 7.42566 7.6435L7.68025 7.89841L8.76006 6.81741C8.94294 6.63437 9.23938 6.63431 9.42222 6.81741C9.60506 7.00044 9.60506 7.29725 9.42222 7.48031L8.01131 8.89275C7.9235 8.98066 7.80441 9.03006 7.68022 9.03006C7.55603 9.03006 7.43694 8.98069 7.34913 8.89275L6.76344 8.30638C6.58059 8.12334 6.58059 7.82653 6.76347 7.6435ZM6.76347 11.0072C6.94634 10.8241 7.24278 10.8241 7.42566 11.0072L7.68025 11.262L8.76006 10.181C8.94291 9.998 9.23938 9.998 9.42222 10.181C9.60506 10.3641 9.60506 10.6609 9.42222 10.8439L8.01131 12.2564C7.92353 12.3443 7.80441 12.3937 7.68022 12.3937C7.55603 12.3937 7.43694 12.3443 7.34913 12.2564L6.76344 11.67C6.58059 11.487 6.58059 11.1902 6.76347 11.0072ZM6.76347 14.1322C6.94634 13.9491 7.24278 13.9491 7.42566 14.1322L7.68025 14.387L8.76006 13.306C8.94291 13.123 9.23938 13.123 9.42222 13.306C9.60506 13.4891 9.60506 13.7859 9.42222 13.9689L8.01131 15.3814C7.92353 15.4693 7.80441 15.5187 7.68022 15.5187C7.55603 15.5187 7.43694 15.4693 7.34913 15.3814L6.76344 14.795C6.58059 14.612 6.58059 14.3152 6.76347 14.1322Z",
    fill: "url(#paint0_linear_64_16602)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48047 3.5625C7.48047 3.73509 7.62022 3.875 7.79263 3.875H13.4114C13.5838 3.875 13.7235 3.73509 13.7235 3.5625V2.3125C13.7235 2.13991 13.5838 2 13.4114 2H7.79263C7.62022 2 7.48047 2.13991 7.48047 2.3125V3.5625Z",
    fill: "url(#paint1_linear_64_16602)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_16602",
    x1: 10.5938,
    y1: 2.9375,
    x2: 10.5938,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6857D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4530B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_64_16602",
    x1: 10.602,
    y1: 2,
    x2: 10.602,
    y2: 3.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6857D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4530B3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.7db7cc33ca806b7ef070cb876f38b7b6.svg";
export { ForwardRef as ReactComponent };